module.exports = __webpack_public_path__ + "img/Cement 2.0aaa9045.png";